"use strict"; // Copyright 2012-2016, Google, Inc.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apis = require("./apis");

var googleapis_common_1 = require("googleapis-common");

exports.AuthPlus = googleapis_common_1.AuthPlus;

var GoogleApis =
/*#__PURE__*/
function (_apis$GeneratedAPIs) {
  _inherits(GoogleApis, _apis$GeneratedAPIs);

  /**
   * GoogleApis constructor.
   *
   * @example
   * const GoogleApis = require('googleapis').GoogleApis;
   * const google = new GoogleApis();
   *
   * @class GoogleApis
   * @param {Object} [options] Configuration options.
   */
  function GoogleApis(options) {
    var _this;

    _classCallCheck(this, GoogleApis);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GoogleApis).call(this));
    _this._discovery = new googleapis_common_1.Discovery({
      debug: false,
      includePrivate: false
    });
    _this.auth = new googleapis_common_1.AuthPlus();
    _this._options = {};

    _this.options(options);

    return _this;
  }
  /**
   * Obtain a Map of supported APIs, along with included API versions.
   */


  _createClass(GoogleApis, [{
    key: "getSupportedAPIs",
    value: function getSupportedAPIs() {
      var apiMap = {};
      Object.keys(apis.APIS).forEach(function (a) {
        apiMap[a] = Object.keys(apis.APIS[a]);
      });
      return apiMap;
    }
    /**
     * Set options.
     *
     * @param  {Object} [options] Configuration options.
     */

  }, {
    key: "options",
    value: function options(_options) {
      this._options = _options || {};
    }
    /**
     * Add APIs endpoints to googleapis object
     * E.g. googleapis.drive and googleapis.datastore
     *
     * @name GoogleApis#addAPIs
     * @method
     * @param {Object} apis Apis to be added to this GoogleApis instance.
     * @private
     */

  }, {
    key: "addAPIs",
    value: function addAPIs(apisToAdd) {
      for (var apiName in apisToAdd) {
        if (apisToAdd.hasOwnProperty(apiName)) {
          // tslint:disable-next-line: no-any
          this[apiName] = apisToAdd[apiName].bind(this);
        }
      }
    }
  }, {
    key: "discover",
    value: function discover(url, callback) {
      if (callback) {
        this.discoverAsync(url).then(function () {
          return callback();
        }).catch(callback);
      } else {
        return this.discoverAsync(url);
      }
    }
  }, {
    key: "discoverAsync",
    value: function () {
      var _discoverAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url) {
        var allApis;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._discovery.discoverAllAPIs(url);

              case 2:
                allApis = _context.sent;
                this.addAPIs(allApis);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function discoverAsync(_x) {
        return _discoverAsync.apply(this, arguments);
      }

      return discoverAsync;
    }()
    /**
     * Dynamically generate an Endpoint object from a discovery doc.
     *
     * @param path Url or file path to discover doc for a single API.
     * @param Options to configure the Endpoint object generated from the
     * discovery doc.
     * @returns A promise that resolves with the configured endpoint.
     */

  }, {
    key: "discoverAPI",
    value: function () {
      var _discoverAPI = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(apiPath) {
        var options,
            endpointCreator,
            ep,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return this._discovery.discoverAPI(apiPath);

              case 3:
                endpointCreator = _context2.sent;
                ep = endpointCreator(options, this);
                ep.google = this; // for drive.google.transporter

                return _context2.abrupt("return", Object.freeze(ep));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function discoverAPI(_x2) {
        return _discoverAPI.apply(this, arguments);
      }

      return discoverAPI;
    }()
  }]);

  return GoogleApis;
}(apis.GeneratedAPIs);

exports.GoogleApis = GoogleApis;